module.exports = __webpack_public_path__ + "static/media/mg.8785f8d0.svg";